<template>
  <div class="component-set-up">
    <el-form :model="colors" :rules="rules" ref="form" label-position="top" label-width="90px">
      <el-form-item v-for="(item,index) in Object.keys(colors)" :label="item" :prop="`${item}.newColor`" :key="index">
        <div class="flex padding-right-8">
          <el-input v-model="colors[item].newColor" @focus="onFocus(index+1)" @change="onCleanUp(colors[item],item)"/>
          <el-color-picker :ref="`colorPicker${index+1}`" v-model="colors[item].newColor" size="medium"
                           @change="onCleanUp(colors[item],item)"/>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { handleGetColor, handleCompareColorCards } from '@/utils/common'
import langConfig from '@/lang'
import { updateStyle } from '../../../../utils/common'

export default {
  name: 'setUp',
  props: {
    originalStyle: {
      type: String
    },
    lang: {
      type: String
    }
  },
  data () {
    const colorValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.langConfig.validate.required[this.lang]))
      } else if (!/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/i.test(value)) {
        return callback(new Error(this.langConfig.validate.format[this.lang]))
      } else {
        callback()
      }
    }
    return {
      langConfig,
      colorValidator,
      colors: {
        Primary: { newColor: '#409eff', oldColor: '#409eff' },
        Success: { newColor: '#67c23a', oldColor: '#67c23a' },
        Warning: { newColor: '#E6A23C', oldColor: '#E6A23C' },
        Danger: { newColor: '#F56C6C', oldColor: '#F56C6C' },
        Info: { newColor: '#909399', oldColor: '#909399' }
      },
      oldStyle: '',
      rules: {
        Primary: {
          newColor: [
            { validator: colorValidator, trigger: 'blur' },
            { validator: colorValidator, trigger: 'change' }
          ]
        }
      }
    }
  },
  created () {
    Object.keys(this.colors).forEach((item) => {
      this.rules[item] = {
        newColor: [
          { validator: this.colorValidator, trigger: 'blur' },
          { validator: this.colorValidator, trigger: 'change' }
        ]
      }
    })
  },
  mounted () {
    this.$watch('originalStyle', (newVal) => {
      if (newVal) {
        const obj = {}
        obj.Primary = handleGetColor(newVal, 'el-button--primary', 'background-color')
        obj.Success = handleGetColor(newVal, 'el-button--success', 'background-color')
        obj.Warning = handleGetColor(newVal, 'el-button--warning', 'background-color')
        obj.Danger = handleGetColor(newVal, 'el-button--danger', 'background-color')
        obj.Info = handleGetColor(newVal, 'el-button--info', 'background-color')
        Object.keys(this.colors).forEach(keyItem => {
          if (obj[keyItem]) {
            if (!this.colors[keyItem].oldColor) {
              this.colors[keyItem].oldColor = obj[keyItem]
            }
            this.colors[keyItem].newColor = obj[keyItem]
          }
        })
        this.oldStyle = newVal
      }
    }, { deep: true, immediate: true })
  },
  methods: {
    onRevokeClick () {
      const obj = {}
      Object.keys(this.colors).forEach((item, index) => {
        this.colors[item].newColor = this.colors[item].oldColor
        obj[`${item}`] = this.colors[item].newColor
      })
      let cssText = handleCompareColorCards(this.oldStyle, obj)
      this.$emit('update:originalStyle', cssText)
      updateStyle(cssText)
    },
    onFocus (index) {
      const that = this
      setTimeout((i) => {
        that.$refs[`colorPicker${i}`][0].showPicker = true
      }, 200, index)
    },
    onCleanUp (e, key) {
      if (!e.newColor) {
        e.newColor = e.oldColor
      }
      const obj = {}
      obj[`${key}`] = e.newColor
      let cssText = handleCompareColorCards(this.oldStyle, obj)
      this.$emit('update:originalStyle', cssText)
      updateStyle(cssText)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/1/Color/setUp.vue